import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import {
  EstimatedCostDto,
  QueryEstimatedCostDto,
  SupportedPropertyTypeDto,
} from "../../types";
import { AxiosResponse } from "axios";

export const getEstimatedCost = async ({
  params,
  signal,
}: {
  params: QueryEstimatedCostDto;
  signal?: AbortSignal;
}): Promise<AxiosResponse<EstimatedCostDto>> => {
  const url = `${EnvironmentVariables.NEW_LISTING_API_URL}/unlocked/estimated-cost`;
  const apiUrl = brandUrl<Promise<EstimatedCostDto>>(url);

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params,
      signal,
    },
  });
};

export const getSupportedPropertyTypes = async ({
  params,
  signal,
}: {
  params: {
    compoundId: number;
  };
  signal?: AbortSignal;
}): Promise<AxiosResponse<SupportedPropertyTypeDto[]>> => {
  const url = `${EnvironmentVariables.NEW_LISTING_API_URL}/unlocked/supported-property-types`;
  const apiUrl = brandUrl<Promise<SupportedPropertyTypeDto[]>>(url);

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params,
      signal,
    },
  });
};
